import utils from '../utils'
const { $, FE } = utils

const MALL_API_DOMAIN = '//api.mall.autohome.com.cn',
  COUPON_API_DOMAIN = '//coupon.mall.autohome.com.cn',
  TEST_MALL_API_DOMAIN = '//mall.api.autohome.com.cn',
  // 提交留资
  SALE_LEAD = '/gateway/saleLead/add',
  // 获取用户手机号
  GET_USER_PHONE = '/gateway/carport/getUserPhone',
  // 关键字搜索
  SEARCH_ITEM = '/gateway/frontitem/searchitem',
  // 获取价格
  GET_PRICE_FOR_LIST = '/item/price/getCpsPriceForList',
  // 获取排行榜
  GET_RANKING_LIST = '/gateway/frontitem/getRankingList',
  // 获取红包集市可以展示的活动
  GET_REDPACKET_MARKET_ACTIVITY = '/gateway/newgift/getRedPacketMarketActivity',
  // 获取偏好车系
  GET_REDPACKET_GOODS = '/gateway/intentionSeries/redPacketGoods',
  // 之家好店
  GET_POP_ITEMS = '/gateway/shop/item/getPopItems',
  // 获取cps城市列表
  GET_CITIES = '/gateway/cps/getCities',
  // 根据商品列表批量查询商品的有效红包信息
  GET_LIST_BY_IDS = '/coupon/getListByIds',
  // 领取红包
  GRANT_COUPON = '/coupon/market/grant',
  // 获取定位城市下交付店
  GET_PROVIDER_LIST = '/gateway/dealer/getProviderDeliveryList'

const request = (url, params = {}) => {
  let defaultData = {
    _appid: 'mall'
  }

  return new Promise((resolve,rejects) => {
    $.ajax({
      url: MALL_API_DOMAIN + url,
      data: $.extend({},defaultData, params),
      type: 'GET',
      dataType: 'jsonp',
      success: function(data){
        resolve(data)
      },
      error: function(error){
        rejects(error)
      }
    })
  })
}

export default {
  request,
  saleLead(params){
    return request(SALE_LEAD, params)
  },
  getUserPhone(){
    return request(GET_USER_PHONE)
  },
  searchItem(params){
    return request(SEARCH_ITEM,{dataSources: '12,17,18',...params})
  },
  getPriceForList(params){
    return request(GET_PRICE_FOR_LIST,params)
  },
  getRankingList(params){
    return request(GET_RANKING_LIST,params)
  },
  getRedPacketMarketActivity(){
    return request(GET_REDPACKET_MARKET_ACTIVITY)
  },
  getRedPacketGoods(cityId,id){
    return request(GET_REDPACKET_GOODS,{ cityId, id })
  },
  getPopItems(cityId,provinceId){
    return request(GET_POP_ITEMS,{ cityId, provinceId })
  },
  getCities(){
    return request(GET_CITIES)
  },
  getListByIds(itemId){
    return new Promise((resolve,rejects) => {
      $.ajax({
        url: COUPON_API_DOMAIN + GET_LIST_BY_IDS,
        data: {
          itemId,
          platform: FE.APP.isApp()?8:2
        },
        type: 'GET',
        dataType: 'jsonp',
        success: function(data){
          resolve(data)
        },
        error: function(error){
          rejects(error)
        }
      })
    })
  },
  getCoupon(data){
    return new Promise((resolve,rejects) => {
      $.ajax({
        url: COUPON_API_DOMAIN + GRANT_COUPON,
        data,
        type: 'GET',
        dataType: 'jsonp',
        success: function(data){
          resolve(data)
        },
        error: function(error){
          rejects(error)
        }
      })
    })
  },
  getProviderDeliverList(cityId){
    return request(GET_PROVIDER_LIST, {
      cityId,
      providerId: 83114480
    })
  },
}


// WEBPACK FOOTER //
// ./src/services/index.js